




































import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { namespace } from 'vuex-class';
import { AuthGroupManager } from '@kasasa/fbase-components/lib';

import { KPortalHeader, KAppToolbar, KAppToolbarBtn, KNoticeContainer, KAppToolbarMenu } from '@kasasa/fbase-components';

const auth = namespace('auth');

@Component({
	name: 'App',
	components: {
		KPortalHeader, KAppToolbar, KNoticeContainer, KAppToolbarBtn, KAppToolbarMenu
	},
	computed: {
		...mapState(['auth'])
	}
})
export default class App extends Vue {
	@auth.State('authManager') authManager!: AuthGroupManager;

	@Watch('$route', { immediate: true, deep: true })
	loadData() {
		if (this.$route.params.siteId) {
			this.$store.dispatch('sites/setSiteIdAction', this.$route.params.siteId);
		}
		if (this.$route.meta.showSelect && this.$route.params.clientId) {
			this.$store.dispatch('sites/setClientId', this.$route.params.clientId);
		}
	}

	chooseSite(siteId: string) {
		this.$store.dispatch('sites/setSiteIdAction', siteId).then(() => {
			this.$router.push(
				{
					name: 'NavList',
					params: {
						clientId: this.$route.params.clientId,
						siteId: this.$store.getters['sites/siteId']
					}
				}
			);
		});
	}

	get showAddNew() {
		return this.$route.params.siteId && this.$route.meta.showAdd && this.authManager.canWrite('navs');
	}

	get isWide(): boolean {
		return !!(this.$route.params.id || this.$route.meta.mode === 'add');
	}
}
